<template>
  <div class="estr-view">
    <div
      class="
        flex flex-col
        items-center
        space-y-4
        lg:space-y-0 lg:items-start lg:flex-row lg:flex-wrap lg:justify-between
      "
    >
      <div v-for="card in cards" :key="card.created_at" class="max-w-screen-sm tomu-flex-item-width">
        <div
            class="
            ring-1
            hover:ring-red-100
            border-t-2 border-gray-100
            shadow-lg
            rounded-md
            space-y-2
            hover:shadow-xl
            divide-y divide-blue-200
          "
        >
          <div class="p-4">
            <h3 class="text-center text-blue-500 text-2xl font-semibold">
              {{ card.name }}
            </h3>
            <div class="">
              <img
                  class="object-contain h-96 w-full"
                  :src="resolveImageUrl(card.image[0])"
                  :alt="card.image[0].alternativeText"
              />
            </div>
            <div class="text-lg">
              <Markdown :source="card.description" />
            </div>
          </div>
          <div class="p-4 flex">
            <div class="w-2/3 flex items-center justify-center">
              <p>Цена: {{ card.price > 0 ? `${card.price} руб` : 'по запросу' }}</p>
            </div>
            <div class="w-1/3 text-right">
              <order-card-modal :digital-driver-card="card" />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Markdown from "vue3-markdown-it";
import {buildUrl} from "@/api/api";
import OrderCardModal from "@/components/modals/OrderCardModal";
export default {
  name: "DigitalDriverCardsList",
  props: {
    cards: Object
  },
  components: { OrderCardModal, Markdown },
  methods: {
    resolveImageUrl(image) {
      const formats = Object.values(image.formats).sort((f1, f2) => f1.size - f2.size);

      if (image.size < 300) {
        return buildUrl(image.url)
      }

      for (let format of formats.reverse()) {
        if (format.size < 600) {
          return buildUrl(format.url)
        }
      }
    }
  }
};
</script>

<style scoped></style>
